export default [
      // aspects 
  {
    path: '/company/corpstandart/type_of_work/aspects/:id',
    name: 'Aspects',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/aspects/aspects.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/corpstandart/type_of_work/aspects/:id/new',
    name: 'NewAspects',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/aspects/new_aspect.vue'),
    meta: { 
      requiresAuth: true
    }
  },
  {
    path: '/company/corpstandart/type_of_work/aspects/:id_aspect/edit',
    name: 'EditAspects',
    props: true,
    component: () => import(/* webpackChunkName: "about" */ '../../../views/companies/corpstandart/aspects/edit_aspect.vue'),
    meta: { 
      requiresAuth: true
    }
  },
]